import { reactive } from "@vue/composition-api";

export default reactive({
  isPdfLoading: false,
  isXlsxLoading: false,
});